// This is more a demonstration of how to use the `ComponentConfig` constant.
// Subclasses of Component should override `ComponentConfig` with their own configuration (eg. `MyComponentConfig = {...}`).
// The three required properties are `componentTypeKey`, `baseHtmlClass` and `selector`.
// These properties are digested by the `Component` class constructor (via `props.config) and used to identify and initialize components.
// The `componentTypeKey` is used to identify the type of component.
// This unique value is used to prevent a component from being initialized more than once on an element.
// The `baseHtmlClass` is used to identify the element that is the root of the component.
// The `selector` is used to find HTML elements that are the root of the component (`this.element`).
// The `elementComponentsKey` is a key for a property that is added to an element that has components. The property stores the components that are initialized on an element.
// The `componentizedWithKey` is a key for a property that is added to an element that has components. The property stores the componentTypeKey strings of the components that are initialized on an element.

import {ComponentizedPropertyName} from "./component_constructor";

export const ComponentConfig = {
    componentTypeKey: 'Component',
    baseHtmlClass: 'component',
    selector: '.component',

    elementComponentsKey: 'components',
    componentizedWithKey: ComponentizedPropertyName,
}
